import React, { useState } from "react";
import MissionImage1 from "../../images/mission-img-1.jpg";
import MissionImage2 from "../../images/mission-img-2.jpg";
import MissionImage3 from "../../images/mission-img-3.jpg";
import MissionImage4 from "../../images/mission-img-4.jpg";
import MissionImage5 from "../../images/mission-img-5.jpg";
import MissionImage6 from "../../images/mission-img-6.jpg";
import MissionImage7 from "../../images/mission-img-7.jpg";
import MissionImage8 from "../../images/mission-img-8.jpg";
import MissionImage9 from "../../images/mission-img-9.jpg";
import IconEndToEnd from "../../icons/icon-end-to-end.svg";
import IconExceedExpectations from "../../icons/icon-exceed-expectations.svg";
import IconDevelopSkills from "../../icons/icon-develop-skills.svg";
import IconDeliverValue from "../../icons/icon-deliver-value.svg";
import IconMasterProcess from "../../icons/icon-master-process.svg";
import InView from "react-intersection-observer";
import HeaderAnim from "../common/utils/animations/textRevealAnimation";
import { motion } from 'framer-motion';
import Parallax from "../common/utils/animations/parallax";
import { directions } from "../common/utils/animations/animationConstants";
import LazyLoad from 'react-lazyload';

const images = [
  {
    image: MissionImage1,
    title: "Innovative Digital Products"
  }, {
    image: MissionImage4,
    title: "Healthcare IT Development"
  }, {
    image: MissionImage7,
    title: "Travel Management Software"
  }, {
    image: MissionImage2,
    title: "eCommerce Development"
  }, {
    image: MissionImage5,
    title: "Design Thinking"
  }, {
    image: MissionImage8,
    title: "Online Food Ordering and Delivery Platform"
  }, {
    image: MissionImage3,
    title: "Custom CRM Development"
  }, {
    image: MissionImage6,
    title: "Alexa Integration"
  }, {
    image: MissionImage9,
    title: "Deal Management Platform"
  },
];

const list = [
  {
    icon: <IconDevelopSkills />,
    title: "Develop Skills",
    content: "We hire carefully and invest heavily in our people to continue to be the best at our craft."
  },
  {
    icon: <IconDeliverValue />,
    title: "Deliver ‘REAL’ Value",
    content: "We stay lean, move fast, and deliver tangible products in days (no $50,000 PPT or vaporware)."
  }, {
    icon: <IconExceedExpectations />,
    title: "Exceed Expectations",
    content: "We work hard, play hard, and never let our customers down."
  }, {
    icon: <IconMasterProcess />,
    title: "Master the Process",
    content: "With 12+ Years and 200+ products, we’ve battle-tested our approach to products, people, and processes."
  }, {
    icon: <IconEndToEnd />,
    title: "Go End-to-End",
    content: "From vision to strategy to a roadmap to delivery and beyond, we go end-to-end -no other vendor needed to fill the gaps."
  },
];

export default function AboutMission() {
  const [isVisible, setIsVisible] = useState(false);
  const [isListVisible, setIsListVisible] = useState(false);

  const listTriggers = [[1, 0.9], [0.95, 0.85], [1, 0.9], [0.95, 0.85], [1, 0.9], [0.95, 0.85],];
  return (
    <div className="about-mission-section section-gap">
      <InView onChange={inView => setIsVisible(inView)} threshold={[0.025]}>
        <div className="container">
          <div className="misson-intro-block section-gap-small">
            <p className="theme-color-title">{isVisible && <HeaderAnim header="OUR MISSION" />}</p>
            <h2 className="secondary-font">Enable every business and person to thrive.</h2>
            <p className="content">At the forefront of technology, we are helping our clients invent their digital future where innovation, automation and  experience are vital to lead and succeed.</p>
          </div>
          <div className="mission-masonary-block section-gap">
            <ul className="row masonary-grid-list">
              {
                images.map((logo, i) => {
                  return <Parallax key={i} id={"masonary-item" + i} direction={directions.BTT} length={100} triggers={[1, 0.8]} opacity={true}>
                    <motion.li className="col masonary-item" >
                      <LazyLoad key={i}>
                        <img src={logo.image} title={logo.title} alt={logo.title} />
                      </LazyLoad>
                    </motion.li></Parallax>;

                  //return <SlideInWithScroll elementTop={top} clientHeight={clientHeight} children={jsx} triggerPoints={triggers[i]} key={i} direction="BTT" length={100} />;
                })
              }
            </ul>
          </div>

          <div className="how-it-works section-gap">
            <div className="how-it-works-title">
              <h2 className="green-gredient-title">We’re one of the few companies<br /> in the world that have end-to-end<br /> expertise to turn ideas into<br /> impactful products. </h2>
              <p>Regardless of the size or shape of the opportunity,<br /> we are your team to deliver on it.</p>
            </div>
            <p className="theme-color-title">{isListVisible && <HeaderAnim header="WHAT DIFFERENTIATES AND DRIVES US" />}</p>
            <InView onChange={inView => setIsListVisible(inView)} threshold={[0.1]}>
              <ul className="work-list two-column">
                {list.map((item, i) => {
                  return <Parallax key={i} id={"work-list" + i} direction={directions.LTR} length={50} triggers={listTriggers[i]} opacity={true}>
                    <motion.li className="work-item">
                      <div className="work-image">{item.icon}</div>
                      <div className="work-content">
                        <h3>{item.title}</h3>
                        <p>{item.content}</p>
                      </div>
                    </motion.li>
                  </Parallax>;
                  //return <SlideInWithScroll elementTop={elementTop[3]} clientHeight={clientHeight} children={jsx} triggerPoints={listTriggers[i]} key={i} />;
                })}
              </ul>
            </InView>
          </div>
        </div>
      </InView>
    </div>
  );
}
